<p-card styleClass="p-card-content-fit">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Exentos del bloqueo de cambios de estado.
        </div>
    </ng-template>
    <div class="p-grid">
        <div class="p-col-12 p-field">
            <label for="roles">Roles</label>
            <p-dropdown name="roles" [options]="roles" [(ngModel)]="selected_role_status" placeholder="Selecciona un rol"
                optionLabel="name" (onChange)="onChangeRole($event)">
            </p-dropdown>
        </div>
        <div class="p-col-12">
            <p-table #grid [value]="parent.transactionStatus.metadata.rolesStatus" [paginator]="true" [rows]="10"
                [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[5,10,25,50]"  paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="id" width="100">ID</th>
                        <th pSortableColumn="name" style="width: 75%;">Nombre</th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-role>
                    <tr>
                        <td>{{role.id}}</td>
                        <td>{{role.name}}</td>
                        <td class="grid-actions">
                            <!--a (click)="edit(role)">
                        <fa-icon [icon]="['far', 'edit']"></fa-icon>
                    </a-->
                            <a (click)="delete(role)" class="color-danger">
                                <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-card>
